// fw DataTable — the name ~10 Office screens already import. RecordList is
// what it renders.
//
// This file used to open "DESKTOP ONLY. For Office." and that sentence was the
// bug. A component was permitted to declare a property about itself — "phones
// are not my problem" — and every screen that imported it inherited the
// declaration silently. Measured in a browser at 360px, the Jobs table came
// out 683px wide with STATUS in column 7, off-screen, on a screen admins use
// from a phone (docs/APP_REBUILD.md §1).
//
// So DataTable is now a name, not a decision. It forwards to RecordList, which
// renders a table when its CONTAINER is at least 768px wide and a stack of
// cards when it is not, and the ~10 call sites became responsive without being
// edited. Nothing about the desktop rendering changed: at >= 768px this is the
// same table, same sticky uppercase header, same right-aligned .fw-num cells,
// same `.fw-table-wrap { overflow-x: auto }` box for a genuinely wide table in
// a genuinely wide pane.
//
// The props are spelled out rather than forwarded as `...props`, for two
// reasons. It is the signature a reader of this file wants; and
// server/utils/__tests__/rebuildRenderHazards.test.js reads the destructured
// parameter list out of this exact file to catch screens handing DataTable a
// prop it does not take (`<DataTable loading={…}>` shipped once and rendered
// "Nobody matches that." about people who were still loading). A `(props)`
// signature would turn that guard off without failing anything.
//
// No default values here: an omitted prop arrives as undefined and picks up
// RecordList's own default, so there is exactly one place each default is
// written.
//
// Column: { key, label, align: 'left'|'right'|'center', render(row), width,
//           role: 'title'|'subtitle'|'badge'|'fact'|'hidden' }.
// align:'right' marks a numeric column: the cell gets .fw-num.
// role is what a card reads; it defaults to 'fact' and is optional everywhere.

import React from 'react';
import { RecordList } from './RecordList.js';

export function DataTable({ columns, rows, rowKey, onRowClick, empty, dense, caption, className, ...rest }) {
  return (
    <RecordList
      columns={columns}
      rows={rows}
      rowKey={rowKey}
      onRowClick={onRowClick}
      empty={empty}
      dense={dense}
      caption={caption}
      className={className}
      {...rest}
    />
  );
}

export default DataTable;
